//componente que muestra una tabla con el importe en € por dia y zona de un centro para una semana concreta (la fecha tiene que ser un día de cierre semanal)
//obtiene los datos de la petición GET cierresemanaldatos/calendario

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

//components:
import NeuriteGrid from '../neurite_grid';

//helpers:
import { getData } from '../../dataLib';

const styles = theme => ({
    buttonsContainer: {
        marginLeft: 16
    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    title: {
        color: theme.palette.secondary.main,
        marginBottom: 40
    },
    grid: {
        marginLeft: 'auto',
        marginRight: 'auto',
    }
});

class CalendarioSemanal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: []
        }
    }

    componentDidMount = () => {
        this.getCalendario();
    }

    getCalendario = () => {
        getData('cierresemanaldatos/calendario?centro_id=' + this.props.centro + '&date=' + this.props.fecha,
            (response) => {

                const totales = { date: '', bolera: 0, bar: 0, arcade: 0, otrosJuegos: 0, parqueInf: 0, cumples: 0, eventos: 0, totales: 0, visas: 0, partidas: 0 };
                response.data.forEach(r => {
                    
                    totales.bolera += r.bolera;
                    totales.bar += r.bar;
                    totales.arcade += r.arcade;
                    totales.otrosJuegos += r.otrosJuegos;
                    totales.parqueInf += r.parqueInf;
                    totales.cumples += r.cumples;
                    totales.eventos += r.eventos;
                    totales.totales += r.totales;
                    totales.visas += r.visas;
                    totales.partidas += r.partidas;
                    totales.isGray = true;
                    totales.isGrayTotal = true;

                    r.isGray = false;
                    r.isGrayTotal = true;
                })

                totales.porcentaje = totales.bolera === 0 ? 100 : parseFloat((totales.bar).toFixed(2)) / parseFloat((totales.bolera).toFixed(2)) * 100;

                this.setState({ ...this.state, rows: [...response.data, totales] })
            },
            (error) => {
                console.log(error);
            },
            this.props.user
        );
    }

    render() {

        const { classes } = this.props;

        return (
            <div>
                <form>


                    <Typography variant="h4" className={classes.title} hidden={!this.props.isDialog}>{'Calendario semanal'}</Typography>

                    <div className={classes.grid}>
                        <NeuriteGrid
                            id="c_s_c"
                            columns={[
                                { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 85, grayField: 'isGray' },
                                { key: 'bolera', name: 'Bolera', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'bar', name: 'Bar', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'porcentaje', name: 'Porcentaje', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'arcade', name: 'Arcade', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'otrosJuegos', name: 'OtrosJuegos', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'parqueInf', name: 'ParqueInf', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'cumples', name: 'Cumples', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'eventos', name: 'Eventos', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'totales', name: 'Totales', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGrayTotal' },
                                { key: 'visas', name: 'Visas', editable: false, dragable: false, type: 'float', width: 80, grayField: 'isGray' },
                                { key: 'partidas', name: 'Partidas', editable: false, dragable: false, type: 'int', width: 80, grayField: 'isGray' }

                            ]}
                            rows={this.state.rows}
                            buttonEdit={false}
                            buttonDelete={false}
                            buttonNew={false}
                            height={317}
                        />
                    </div>

                    <div>
                        <Button className={classes.button} variant="contained" color="secondary" onClick={() => this.props.hideDialog()} hidden={!this.props.isDialog}>Cerrar</Button>
                    </div>

                </form>

            </div>
        );
    };

};

CalendarioSemanal.propTypes = {

    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    user: PropTypes.object.isRequired,

    semanaCerrada: PropTypes.bool.isRequired,
    multiplicador: PropTypes.number.isRequired

};



export default withStyles(styles, { withTheme: true })(CalendarioSemanal);